import { mutator } from 'satcheljs';
import { setShouldShowPivotEnableDisableDialog } from '../actions/internalActions';
import store from '../store/Store';

mutator(setShouldShowPivotEnableDisableDialog, actionMessage => {
    store.isPivotEnableDisableDialogShown = actionMessage.shouldShow;
});
